import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const HotmartSection = () => {
  const featuredLinks = [
    {
      title: "Desenhar Cabeças - Curso De Desenho",
      url: "https://go.hotmart.com/X76584040N",
      description: "Aprenda técnicas profissionais para desenhar cabeças e rostos com precisão e realismo."
    },
    {
      title: "Emagreça em 7 dias",
      url: "https://go.hotmart.com/P3133182e?ap=28d5",
      description: "Programa de emagrecimento rápido com resultados visíveis em apenas uma semana."
    },
    {
      title: "Desafio do Emagrecimento",
      url: "https://go.hotmart.com/L64628560K",
      description: "Transforme seu corpo com este desafio completo de emagrecimento e bem-estar."
    }
  ];

  return (
    <section id="hotmart" className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Produtos Hotmart Recomendados
          </h2>
          <p className="mt-2 text-muted-foreground max-w-3xl mx-auto">
            Cursos, produtos e serviços de qualidade disponíveis na plataforma Hotmart
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredLinks.map((link, index) => (
            <Card key={index} className="overflow-hidden border-border hover:border-primary/50 transition-colors">
              <CardHeader>
                <CardTitle className="line-clamp-1">{link.title}</CardTitle>
                <CardDescription className="line-clamp-2">{link.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="bg-muted p-3 rounded-md overflow-hidden">
                  <span className="text-sm text-muted-foreground truncate block">{link.url}</span>
                </div>
              </CardContent>
              <CardFooter>
                <Button 
                  className="w-full" 
                  onClick={() => window.open(link.url, "_blank")}
                >
                  Acessar
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/hotmart">
            <Button variant="outline" className="group">
              Ver todos os produtos
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HotmartSection;